// extracted by mini-css-extract-plugin
export var smallSpinner = "_rf-0";